import {
  DialogTrigger,
  LinkButton,
  Popover,
  PopoverContent,
} from "@certn/cascadia-react";
import { Trans } from "react-i18next";

export function ApiKeyWhatsThis() {
  return (
    <DialogTrigger>
      <LinkButton testID="" textStyle="form/body-secondary-link">
        <Trans>What's this?</Trans>
      </LinkButton>
      <Popover placement="top right">
        <PopoverContent>
          <Trans>
            Your Lever API key allows Certn to seamlessly integrate with your
            Lever account. You can find your key in Lever by navigating to:
            <br />
            <br />
            Settings → Integrations and API → Partner Integrations → Certn → API
            Key
          </Trans>
        </PopoverContent>
      </Popover>
    </DialogTrigger>
  );
}
